import { accountantLoginApiUrl } from "../../constants/apis/account_apis";
import { loginApiUrl, medicalLoginApiUrl } from "../../constants/apis/clinic_apis";
import axios from "axios";

export const loginApi = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const response = await axios.post(loginApiUrl, data, config);

    return response;
};

export const accountLoginApi = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const response = await axios.post(accountantLoginApiUrl, data, config);

    return response;
};

export const medicalLoginApi = async (data) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const response = await axios.post(medicalLoginApiUrl, data, config);

    return response;
};
